import React, { Component } from 'react';

class ErrorBoundary extends Component {

    state = {
        hasError: false,
        errorMessage: ''
    }

    // static getDerivedStateFromError(error) {
    //     // Update state so the next render will show the fallback UI.
    //     return { hasError: true };
    // }

    // componentDidCatch(error, errorInfo) {
    //     // You can also log the error to an error reporting service
    //     logErrorToMyService(error, errorInfo);
    // }

    componentDidCatch = (error, info) => {
        this.setState({
            hasError: true,
            errorMessage: error
        })
    }

    render() {        
        var s3BaseUrl = process.env.REACT_APP_S3_URL;
        var imagePath = s3BaseUrl+"/assets/images/404.png"
        if (this.state.hasError) {
            return (
                <div style={{textAlign:'center',width:'80%',margin:'auto',marginTop:'50px'}}>
                <img src={imagePath} alt="404 Some error occured" />
                <h1 style={{color:'black'}}>Some error occurred.</h1>
                </div>
                
            )
        } else {
            return (
                this.props.children
            )
        }
    }
}

export default ErrorBoundary;